var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecial5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "470px",
    height: "180px",
    viewBox: "110 190 30 35",
    id: "svg19136",
    inkscape: "http://www.inkscape.org/namespaces/inkscape",
    sodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs19133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20890"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#074e9c",
      strokeWidth: 1.17288,
      strokeLinecap: "square",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "normal"
    },
    id: "rect294183-7-4",
    width: 74.136726,
    height: 24.246552,
    x: 88.58548,
    y: 193.13513
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\u0420\\u0415\\u0426\\u0415\\u041F\\u0422 \\u0414\\u0415\\u0419\\u0421\\u0422\\u0412\\u0418\\u0422\\u0415\\u041B\\u0415\\u041D",
    id: "text107154-3",
    style: {
      fontSize: "7.05556px",
      lineHeight: 1.25,
      fontFamily: "Roboto",
      InkscapeFontSpecification: "Roboto",
      display: "inline",
      fill: "#074e9c",
      strokeWidth: 0.264583
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 113.50256,200.89484 v 1.76733 h -1.03353 v -5.01606 h 1.95681 q 0.565,0 0.99219,0.2067 0.43064,0.20671 0.66146,0.58912 0.23082,0.37896 0.23082,0.86472 0,0.73725 -0.50643,1.16444 -0.50298,0.42375 -1.39526,0.42375 z m 0,-0.83716 h 0.92328 q 0.40997,0 0.62357,-0.19293 0.21704,-0.19292 0.21704,-0.55121 0,-0.36863 -0.21704,-0.59601 -0.21704,-0.22737 -0.59945,-0.23426 h -0.9474 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.03791,200.48831 h -1.98438 v 1.34359 h 2.32889 v 0.83027 H 117.02 v -5.01606 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 120.94397,197.64611 h 1.03353 v 4.18579 h 2.00849 v -4.18579 h 1.03698 v 4.18579 h 0.68557 l -0.0689,2.0395 h -0.96463 v -1.20923 h -3.73104 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.36034,200.48831 h -1.98437 v 1.34359 h 2.32888 v 0.83027 h -3.36241 v -5.01606 h 3.35552 v 0.83716 h -2.32199 v 1.19545 h 1.98437 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20821"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.39708,202.66217 h -1.03698 v -4.1789 h -2.00849 v 4.1789 h -1.03353 v -5.01606 h 4.079 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20823"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 139.07896,198.48327 h -1.53651 v 4.1789 h -1.03353 v -4.1789 h -1.51584 v -0.83716 h 4.08588 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 103.3533,212.71497 h -0.95429 v -1.23335 h -3.024798 v 1.2299 h -0.978407 l -0.05512,-2.06017 h 0.378961 q 0.306614,-0.25494 0.471978,-0.74758 0.16881,-0.4961 0.227377,-1.22646 l 0.144694,-2.21175 h 3.286627 v 4.18579 h 0.58566 z m -3.448542,-2.06362 h 1.912032 v -3.34863 h -1.27124 l -0.0861,1.31947 q -0.10335,1.32636 -0.554662,2.02916 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 106.99477,209.30776 h -1.98438 v 1.34359 h 2.32889 v 0.83027 h -3.36242 v -5.01606 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 110.95319,206.46556 h 1.03697 v 5.01606 h -1.03697 v -3.33141 l -2.0085,3.33141 h -1.03353 v -5.01606 h 1.03353 v 3.3383 z m 0.19981,-1.31947 q 0,0.45819 -0.33073,0.74069 -0.32728,0.2825 -0.86127,0.2825 -0.53399,0 -0.86472,-0.27905 -0.32729,-0.27906 -0.32729,-0.74414 h 0.70625 q 0,0.21704 0.12747,0.33762 0.13091,0.11713 0.35829,0.11713 0.22393,0 0.3514,-0.11713 0.12747,-0.12058 0.12747,-0.33762 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20831"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 116.82363,209.81075 q -0.0586,0.8096 -0.59944,1.27468 -0.53744,0.46509 -1.41939,0.46509 -0.96462,0 -1.51928,-0.64768 -0.55122,-0.65112 -0.55122,-1.78456 v -0.30661 q 0,-0.72347 0.25494,-1.27469 0.25494,-0.55121 0.72691,-0.84405 0.47543,-0.29627 1.10244,-0.29627 0.86816,0 1.3987,0.46508 0.53055,0.46509 0.61323,1.3057 h -1.03353 q -0.0379,-0.48576 -0.27216,-0.7028 -0.23082,-0.22049 -0.70624,-0.22049 -0.51677,0 -0.77515,0.37207 -0.25494,0.36863 -0.26183,1.14722 v 0.37896 q 0,0.81304 0.2446,1.18856 0.24805,0.37551 0.77859,0.37551 0.47887,0 0.71314,-0.21704 0.23771,-0.22048 0.27216,-0.67868 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.16101,207.30272 h -1.53651 v 4.1789 h -1.03353 v -4.1789 h -1.51585 v -0.83716 h 4.08589 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20835"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 121.75012,211.48162 v -5.01606 h 1.757 q 0.91295,0 1.38493,0.3514 0.47198,0.34795 0.47198,1.02319 0,0.36863 -0.18948,0.65113 -0.18948,0.27905 -0.5271,0.40996 0.38585,0.0965 0.60634,0.3893 0.22393,0.29283 0.22393,0.71658 0,0.72347 -0.46165,1.09554 -0.46164,0.37207 -1.31602,0.37896 z m 1.03353,-2.18419 v 1.35392 h 0.88539 q 0.36518,0 0.56844,-0.17225 0.20671,-0.1757 0.20671,-0.48232 0,-0.68902 -0.71314,-0.69935 z m 0,-0.73036 h 0.76481 q 0.78204,-0.0138 0.78204,-0.62356 0,-0.34107 -0.19982,-0.48921 -0.19637,-0.15158 -0.62356,-0.15158 h -0.72347 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 129.26043,206.46556 h 1.03698 v 5.01606 h -1.03698 v -3.33141 l -2.00849,3.33141 h -1.03353 v -5.01606 h 1.03353 v 3.3383 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 134.9414,207.30272 h -1.53651 v 4.1789 h -1.03353 v -4.1789 h -1.51585 v -0.83716 h 4.08589 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20841"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.54842,209.30776 h -1.98438 v 1.34359 h 2.32889 v 0.83027 h -3.36242 v -5.01606 h 3.35553 v 0.83716 h -2.322 v 1.19545 h 1.98438 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 143.57826,206.46556 v 5.01606 h -1.03697 v -4.1789 h -1.3367 l -0.0827,1.77078 q -0.0517,0.89572 -0.22738,1.41249 -0.1757,0.51332 -0.51332,0.75447 -0.33762,0.23772 -0.92328,0.24116 h -0.26872 v -0.83027 l 0.17225,-0.0172 q 0.3893,-0.0517 0.55466,-0.44787 0.16881,-0.39963 0.2136,-1.41938 l 0.0861,-2.30132 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20845"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 147.49878,209.30776 h -1.98437 v 1.34359 h 2.32888 v 0.83027 h -3.36241 v -5.01606 h 3.35552 v 0.83716 h -2.32199 v 1.19545 h 1.98437 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 152.53207,211.48162 h -1.03353 v -2.14974 h -2.01538 v 2.14974 h -1.03353 v -5.01606 h 1.03353 v 2.03261 h 2.01538 v -2.03261 h 1.03353 z",
    style: {
      fontWeight: "bold",
      InkscapeFontSpecification: "'Roboto Bold'",
      textAlign: "center",
      textAnchor: "middle"
    },
    id: "path20849"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecial5);
export default __webpack_public_path__ + "static/media/Special5.adffb109ff19b50f3fc1f3312c187f1c.svg";
export { ForwardRef as ReactComponent };